module.exports = __webpack_public_path__ + "img/sea.95bcf883.png";